/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class FileApi extends runtime.BaseAPI {
    /**
     * Delete File
     */
    async deleteFileRaw(requestParameters, initOverrides) {
        if (requestParameters['userFileId'] == null) {
            throw new runtime.RequiredError('userFileId', 'Required parameter "userFileId" was null or undefined when calling deleteFile().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/file/{user_file_id}`;
        urlPath = urlPath.replace(`{${"user_file_id"}}`, encodeURIComponent(String(requestParameters['userFileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete File
     */
    async deleteFile(requestParameters, initOverrides) {
        await this.deleteFileRaw(requestParameters, initOverrides);
    }
    /**
     * Get File
     */
    async getFileRaw(requestParameters, initOverrides) {
        if (requestParameters['userFileId'] == null) {
            throw new runtime.RequiredError('userFileId', 'Required parameter "userFileId" was null or undefined when calling getFile().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/file/{user_file_id}`;
        urlPath = urlPath.replace(`{${"user_file_id"}}`, encodeURIComponent(String(requestParameters['userFileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get File
     */
    async getFile(requestParameters, initOverrides) {
        const response = await this.getFileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Storage Info
     */
    async getStorageInfoRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['fileType'] != null) {
            queryParameters['file_type'] = requestParameters['fileType'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/file/storage`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Storage Info
     */
    async getStorageInfo(requestParameters = {}, initOverrides) {
        const response = await this.getStorageInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List Files
     */
    async listFilesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['fileType'] != null) {
            queryParameters['file_type'] = requestParameters['fileType'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/file`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List Files
     */
    async listFiles(requestParameters = {}, initOverrides) {
        const response = await this.listFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Share File
     */
    async shareFileForUsernameRaw(requestParameters, initOverrides) {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling shareFileForUsername().');
        }
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError('username', 'Required parameter "username" was null or undefined when calling shareFileForUsername().');
        }
        const queryParameters = {};
        if (requestParameters['username'] != null) {
            queryParameters['username'] = requestParameters['username'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/file/{file_id}/share`;
        urlPath = urlPath.replace(`{${"file_id"}}`, encodeURIComponent(String(requestParameters['fileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Share File
     */
    async shareFileForUsername(requestParameters, initOverrides) {
        await this.shareFileForUsernameRaw(requestParameters, initOverrides);
    }
    /**
     * Update File Label
     */
    async updateFileLabelRaw(requestParameters, initOverrides) {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling updateFileLabel().');
        }
        if (requestParameters['newLabel'] == null) {
            throw new runtime.RequiredError('newLabel', 'Required parameter "newLabel" was null or undefined when calling updateFileLabel().');
        }
        const queryParameters = {};
        if (requestParameters['newLabel'] != null) {
            queryParameters['new_label'] = requestParameters['newLabel'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/file/{file_id}`;
        urlPath = urlPath.replace(`{${"file_id"}}`, encodeURIComponent(String(requestParameters['fileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update File Label
     */
    async updateFileLabel(requestParameters, initOverrides) {
        await this.updateFileLabelRaw(requestParameters, initOverrides);
    }
    /**
     * Upload File
     */
    async uploadFileRaw(requestParameters, initOverrides) {
        if (requestParameters['fileType'] == null) {
            throw new runtime.RequiredError('fileType', 'Required parameter "fileType" was null or undefined when calling uploadFile().');
        }
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling uploadFile().');
        }
        const queryParameters = {};
        if (requestParameters['fileType'] != null) {
            queryParameters['file_type'] = requestParameters['fileType'];
        }
        if (requestParameters['label'] != null) {
            queryParameters['label'] = requestParameters['label'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file']);
        }
        let urlPath = `/api/v2/file`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Upload File
     */
    async uploadFile(requestParameters, initOverrides) {
        const response = await this.uploadFileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload File For User
     */
    async uploadFileForUserRaw(requestParameters, initOverrides) {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError('username', 'Required parameter "username" was null or undefined when calling uploadFileForUser().');
        }
        if (requestParameters['fileType'] == null) {
            throw new runtime.RequiredError('fileType', 'Required parameter "fileType" was null or undefined when calling uploadFileForUser().');
        }
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling uploadFileForUser().');
        }
        const queryParameters = {};
        if (requestParameters['fileType'] != null) {
            queryParameters['file_type'] = requestParameters['fileType'];
        }
        if (requestParameters['label'] != null) {
            queryParameters['label'] = requestParameters['label'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file']);
        }
        let urlPath = `/api/v2/file/users/{username}`;
        urlPath = urlPath.replace(`{${"username"}}`, encodeURIComponent(String(requestParameters['username'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Upload File For User
     */
    async uploadFileForUser(requestParameters, initOverrides) {
        const response = await this.uploadFileForUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
